import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button", "copyButton", "formattedContent", "clippable", "icon"]

  connect() {
    this.isExpanded = false
    this.hideButtonIfNoDetails()
  }

  hideButtonIfNoDetails() {
    const el = this.hasClippableTarget ? this.clippableTarget : null
    if (el && this.hasButtonTarget) {
      if (!el.querySelector("details")) {
        this.buttonTarget.classList.add("hidden")
      }
    }
  }

  toggle(event) {
    this.isExpanded = !this.isExpanded

    if (this.hasClippableTarget) {
      const details = this.clippableTarget.querySelectorAll("details")
      details.forEach(detail => detail.open = this.isExpanded)
    } else {
      // Toggle content visibility (for non-formatted expandables)
      this.contentTargets.forEach(target => {
        target.classList.toggle("hidden")
      })
    }

    // Rotate icon if present
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = this.isExpanded ? "rotate(90deg)" : "rotate(0deg)"
    }

    // Update button text if present
    if (this.hasButtonTarget) {
      this.updateButtonText()
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  updateButtonText() {
    let buttonText = this.isExpanded ? "Collapse All" : "Expand All"
    this.buttonTarget.innerText = buttonText
  }

  copy() {
    const contentElement = this.contentTarget
    const content = contentElement.textContent.trim()
    const button = this.element.querySelector('[data-action="click->expandable#copy"]')

    navigator.clipboard.writeText(content).then(() => {
      button.textContent = "Copied!"
      setTimeout(() => {
        button.textContent = "Copy"
      }, 2000)
    }).catch(err => {
      console.error('Failed to copy content: ', err)
      button.textContent = "Copy failed"
      setTimeout(() => {
        button.textContent = "Copy"
      }, 2000)
    })
  }
}
